import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const NAV = [
  ["Home", "/#top"], ["The Space", "/#space"], ["Amenities", "/#amenities"], ["Location", "/#location"],
  ["Gallery", "/#gallery"], ["FAQs", "/#faqs"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-background/95 border-b border-border" data-testid="site-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 px-4 sm:px-8 lg:px-12 h-16">
        <Link to="/" className="font-serif text-lg sm:text-2xl tracking-tight whitespace-nowrap" data-testid="brand-link">
          Garage Getaway <span className="italic text-[hsl(var(--sage))]">Beaumont</span>
        </Link>
        <a href="tel:+14093653256" className="lg:hidden ml-auto inline-flex shrink-0 items-center gap-1 whitespace-nowrap border border-primary px-2.5 py-1.5 rounded-full text-[11px] font-semibold" data-testid="header-call-button-mobile"><Phone className="w-3.5 h-3.5" /> Call (409) 365-3256</a>
        <nav className="hidden lg:flex items-center gap-7 text-sm">
          {NAV.map(([l, h]) => (
            <a key={l} href={h} className="hover:text-[hsl(var(--sage))] transition-colors" data-testid={`nav-${l.toLowerCase().replace(/\s/g, "-")}`}>{l}</a>
          ))}
          <a href="tel:+14093653256" className="inline-flex items-center gap-2 border border-primary px-4 py-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-colors" data-testid="header-call-button"><Phone className="w-4 h-4" /> (409) 365-3256</a>
          <Link to="/book" className="bg-primary text-primary-foreground px-5 py-2.5 rounded-full hover:bg-[hsl(var(--sage))] transition-colors" data-testid="nav-book-your-stay">Book Your Stay</Link>
        </nav>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="lg:hidden p-1 shrink-0" aria-label="Open menu" data-testid="mobile-menu-button"><Menu className="w-6 h-6" /></SheetTrigger>
          <SheetContent side="right" className="bg-background">
            <SheetTitle className="font-serif text-2xl">Menu</SheetTitle>
            <div className="flex flex-col gap-5 mt-8 text-lg">
              {NAV.map(([l, h]) => <a key={l} href={h} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.toLowerCase().replace(/\s/g, "-")}`}>{l}</a>)}
              <Link to="/book" onClick={() => setOpen(false)} className="bg-primary text-primary-foreground px-5 py-3 rounded-full text-center" data-testid="mobile-nav-book">Book Your Stay</Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
